<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_title: '有效问答',
				modal_model: false,
				modal_width: 1200,
				modal_height: 800,
				list_footerField: [{
					field: 'needamount',
					toFixed: 2
				}]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {

			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						field: 'mordId',
						title: '单号',
						width: 150
					},
					{
						field: 'buyerNick',
						title: '客户',
						width: 100
					},
					{
						field: 'accountNick',
						title: '客服',
						width: 100
					},
					{
						field: 'question',
						title: '问题',

					},
					{
						field: 'answer',
						title: '答案',
					},
					{
						field: 'time',
						title: '时间',
						width: 100
					}, {
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 80,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.chartdetail(row)}}>聊天详情</el-button>]
							}
						}
					},
				]
				gridOptions.formConfig = false
				gridOptions.showOverflow = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.knowledge.getDetail({
						itemId: this.row.itemId
					}).then((res) => {
						let data = []
						res.forEach((item) => {
							item.knowledge.forEach((_item) => {
								let obj = {}
								obj.sourcechart = item.sourcechart
								obj.mordId = item.mordId
								obj.buyerNick = item.buyerNick
								obj.accountNick = item.accountNick
								obj.question = _item['问题']
								obj.answer = _item['答案']
								obj.time = this.$Moment(item.createTime * 1000).format(
									'YYYY-MM-DD')
								data.push(obj)
							})
						})
						//console.log(res)
						resolve({
							list: data
						})
					})
				})
			},
			chartdetail(e){
				console.log(e)
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>